import { Extension } from "../../core/extension";
import { Placeholder } from "./plugins";
export class PlaceholderExtension extends Extension {
    constructor(options) {
        super();
        this.options = options;
    }
    addPlugins(schema, plugins) {
        return plugins.concat([Placeholder(this.options)]);
    }
}
